import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import Backend from 'i18next-http-backend';

i18n
    .use(Backend) // Carga traducciones de /public/locales
    .use(LanguageDetector) // Detecta el idioma del navegador
    .use(initReactI18next) // Pasa i18n a react-i18next
    .init({
        lng: 'es', // Idioma por defecto para todos los usuarios
        fallbackLng: 'es', // Idioma de respaldo - español por defecto
        debug: false, // Habilitar depuración en desarrollo
        interpolation: {
            escapeValue: false, // React ya previene ataques XSS
        },
        backend: {
            loadPath: '/locales/{{lng}}/translation.json', // Ruta a tus archivos de traducción
        },
        detection: {
            order: ['localStorage', 'cookie'], // Solo usar preferencia guardada por el usuario
            caches: ['localStorage', 'cookie'],
        },
        // ns: ["translation"], // Espacio de nombres por defecto
        // defaultNS: "translation"
    });

export default i18n;
